import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import VideoCard from '@/components/feature/VideoCard';
import { categories, getVideosByCategory } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find(c => c.slug === slug);
  const categoryVideos = slug ? getVideosByCategory(slug) : [];

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: category ? `${category.name} - 555电影` : '分类 - 555电影',
    description: category
      ? `在线观看${category.name}全集，高清不缓冲。555电影为您精选最新${category.name}资源。`
      : '按分类浏览影视资源',
    url: `https://www.555movie.com/category/${slug}`,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-12">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-[1200px] mx-auto">
              <div className="mb-4">
                <Breadcrumb
                  items={[
                    { label: '首页', href: '/' },
                    { label: category?.name || '分类' },
                  ]}
                />
              </div>

              <div className="mb-8">
                <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                  {category?.name || '分类'}
                </h1>
                <p className="text-sm text-foreground-500">
                  {category
                    ? `共 ${categoryVideos.length} 部${category.name}，高清不缓冲，追剧首选`
                    : '请选择一个分类'}
                </p>
              </div>

              <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      slug === cat.slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                    }`}
                  >
                    <i className={`${cat.icon} text-sm`}></i>
                    <span>{cat.name}</span>
                  </Link>
                ))}
              </div>

              {categoryVideos.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
                  {categoryVideos.map((video) => (
                    <VideoCard
                      key={video.id}
                      id={video.id}
                      title={video.title}
                      category={video.category}
                      year={video.year}
                      rating={video.rating}
                      posterUrl={video.posterUrl}
                      status={video.status}
                      categoryName={category?.name || ''}
                    />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                    <i className="ri-movie-2-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无内容</p>
                  <Link
                    to="/"
                    className="inline-flex items-center gap-1 mt-4 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer"
                  >
                    <i className="ri-arrow-left-line"></i>
                    <span>返回首页</span>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}